/**
 * @fileoverview Barrel exports for the generate-world-element-portrait-v2 COMPOSITE agent.
 *
 * This composite orchestrates:
 * - world-element-image-prompt-creator-v2 (sequential, prompt generation)
 * - world-element-image-creator-fal-v2 (sequential, FAL.ai image generation)
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Orchestration logic (prompt creation → image generation)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, generateWorldElementPortraitV2AgentFlow } from './flow';

